<template>
  <div style="max-width:60vh" class="mx-auto">
    <div class="text-4 gray--text mt-10 text-center">
      Use imToken2.0 DApp browser scan this QR Code to continue
    </div>
    <div class="p-relative mt-3">
      <img class="width-100" :src="dataUrl" style="max-width: 100%" />
      <span id="targetUrl" class="white--text-abs p-absolute site-url-text">{{
        targetUrl
      }}</span>
    </div>
    <div class="d-flex align-center justify-space-between mt-5">
      <c-btn is-secondary class="copy-url" data-clipboard-target="#targetUrl"
        >Copy URL</c-btn
      >
      <c-btn @click="$emit('next')">Continue</c-btn>
    </div>
  </div>
</template>

<script>
import QrCode from "qrcode";
import Clipboard from "clipboard";
import { mapGetters } from "vuex";

export default {
  props: ["context", "data"],
  computed: mapGetters({
    isMobile: "appConfig/isMobile",
    accessToken: "auth/accessToken",
  }),
  data: () => ({
    targetUrl: null,
    dataUrl: null,
  }),
  async mounted() {
    this.targetUrl =
      window.location.origin +
      this.$router.resolve({
        path: this.$route.path,
        query: {
          accessToken: this.accessToken,
          ctx: this.context,
          data: btoa(JSON.stringify(this.data || {})),
        },
      }).href;
    const imTokenDeeplink = `imtokenv2://navigate?screen=DappView&url=${encodeURIComponent(
      this.targetUrl
    )}`;
    this.dataUrl = await QrCode.toDataURL(imTokenDeeplink, {
      scale: 6,
      errorCorrectionLevel: "H",
    });
    if (this.isMobile) {
      const anchor = document.createElement("a");
      anchor.href = imTokenDeeplink;
      anchor.style.display = "none";
      anchor.click();
      anchor.remove();
    }
    const clipboard = new Clipboard(".copy-url");
  },
};
</script>


<style lang="scss" scoped>
.site-url-text {
  z-index: -1;
  font-size: 1px;
  bottom: 7px;
  right: 0;
}
</style>